import { useState, useEffect } from "react";
import { MdList, MdAssignment, MdOutlineSchedule, MdEvent, MdCheckCircle, MdAnalytics } from "react-icons/md";
import { useFilters } from "features/filters/store";
import { Icon } from "../Icon";
import { Container, SubModulesNavHeader, Button, CxBoxRelaship, IndicatorValue, IndicatorContent, IndicatorLabel, IndicatorIcon, FloatingIndicators, ShowInfoRelatorio } from "./styles";
import { useMenuFilterIndex } from "core/features/filters/hooks/useMenuFilterIndex";
import useRelatorioContext from "../../hooks/useRelatorioContext";
import { IoMdEye, IoMdEyeOff } from "react-icons/io";
import { Tooltip } from "antd";

export function Tabbar() {
    const { setIndexOpen } = useMenuFilterIndex();
    const { aderenteExec, naoAderenteExec, mediaDesvio, porcentagem } = useRelatorioContext();
    const [infoRelatorio, setInfoRelatorio] = useState(true);
    const list = [
        {
            icon: MdList,
            name: "Cadastros",
            label: 'cadastros'
        },
        {
            icon: MdAssignment,
            name: "Execução Operacional",
            label: 'execucao-operacional'
        },
        {
            icon: MdEvent,
            name: "Agenda de Campo",
            label: 'agenda-campo'
        },
        {
            icon: MdOutlineSchedule,
            name: "Relatórios",
            label: 'relatorios'
        },
    ]

    const listStatusMapRelaship = [
        {
            icon: MdCheckCircle,
            name: "Aderência",
            value: `${porcentagem}%`,
            text: 'Percentual de aderência entre planejado e executado',
            color: "#16a34a",
            backgroundColor: "#dcfce7"
        },
        {
            icon: MdOutlineSchedule,
            name: "No Prazo",
            value: aderenteExec,
            text: 'Operações executadas dentro do prazo planejado',
            color: "#2563eb",
            backgroundColor: "#dbeafe"
        },
        {
            icon: MdOutlineSchedule,
            name: "Fora do Prazo",
            value: naoAderenteExec,
            text: 'Operações executadas fora do prazo planejado',
            color: "#dc2626",
            backgroundColor: "#fee2e2"
        },
        {
            icon: MdAnalytics,
            name: "Desvio Médio",
            value: Math.abs(Number(mediaDesvio.toFixed(2))).toLocaleString('pt-BR'),
            text: 'Média de desvio em dias entre planejado e executado',
            color: "#d97706",
            backgroundColor: "#fef3c7"
        },
    ]
    const { filters: { tabBarSessaoPlanejamentoOperacional, menuNameRelatorios }, updateField } = useFilters();

    useEffect(() => {
        if (!tabBarSessaoPlanejamentoOperacional) {
            updateField('tabBarSessaoPlanejamentoOperacional', 'cadastros');
        }
    }, []);
    const handleToggleSessao = (item: string) => {
        updateField('tabBarSessaoPlanejamentoOperacional', item);
        setIndexOpen(null);
    }

    return (
        <Container>
            <SubModulesNavHeader>
                {
                    list.map((item, index) => (
                        <Button 
                            active={tabBarSessaoPlanejamentoOperacional === item.label}
                            key={index} onClick={() => handleToggleSessao(item.label)}
                        >
                            <Icon icon={item.icon} color="#666" />
                            <span>{item.name}</span>
                        </Button>
                    ))
                }
            </SubModulesNavHeader>
            {tabBarSessaoPlanejamentoOperacional === 'relatorios' && menuNameRelatorios === "Relatório de Aderência Operacional" && (
             <>
             {infoRelatorio && (
                <FloatingIndicators>
                    {
                    listStatusMapRelaship.map((item, index) => (
                        <Tooltip title={item.text} key={index}>
                            <CxBoxRelaship key={index}>
                                <IndicatorIcon color={item.color} backgroundColor={item.backgroundColor}>
                                    <Icon icon={item.icon} />
                                </IndicatorIcon>
                                <IndicatorContent>
                                    <IndicatorValue>{item.value}</IndicatorValue>
                                    <IndicatorLabel>{item.name}</IndicatorLabel>
                                </IndicatorContent>
                            </CxBoxRelaship>
                        </Tooltip>
                    ))
                }
                </FloatingIndicators>  
             )}
                <ShowInfoRelatorio onClick={() => setInfoRelatorio(!infoRelatorio)}>
                    {infoRelatorio ? <IoMdEye fontSize="28px" title="Legendas" fill="#fff" /> : <IoMdEyeOff fontSize="28px" fill="#fff" title="Legendas" />}
                </ShowInfoRelatorio>
             </>
            )}
   
      </Container>
    )
}